import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=17e912a8&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=17e912a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e912a8",
  null
  
)

export default component.exports